import React from 'react';
import styled from 'styled-components';

import { Heading } from '@rover/kibble/core';

import CaptionedImage, { Props as CaptionedImageProps } from '../CaptionedImage';

export const StyledHeading = styled(Heading)`
  font-family: inherit;
  color: inherit;
  font-size: 26px;
  font-weight: ${({ theme }) => theme.fontWeight.regular};
  line-height: 1.4;
  margin-top: 0;
  margin-bottom: ${({ theme }) => theme.space['4x']};
`;

export const AttributionWrapper = styled.span`
  display: inline;
  color: ${({ theme }) => theme.textColor.tertiary};
`;

const SubTextWrapper = styled.div`
  margin-top: ${({ theme }) => theme.space['6x']};
  font-size: ${({ theme }) => theme.text['200'].fontSize};
`;

const renderSubtext = (subText, linkText, linkUrl) => {
  if (subText) {
    return (
      <SubTextWrapper>
        {subText}&nbsp;
        <a href={linkUrl}>{linkText}</a>
      </SubTextWrapper>
    );
  }

  return null;
};

export type Props = Omit<
  CaptionedImageProps & {
    quote: string;
    attribution: string;
    subText?: string;
    linkText?: string;
    linkUrl?: string;
  },
  'children' | 'ref'
>;

const QuoteCaptionedImage = ({
  imageSrc,
  imageCreditText,
  imageLocationText,
  position,
  quote,
  attribution,
  subText,
  linkText,
  linkUrl,
  ...other
}: Props): JSX.Element => (
  <CaptionedImage
    imageSrc={imageSrc}
    imageCreditText={imageCreditText}
    imageLocationText={imageLocationText}
    position={position}
    {...other}
  >
    {/* role="text" is not a valid ARIA role, but prevents screenreaders "splitting" elements: https://axesslab.com/text-splitting/ */}
    {/* eslint-disable-next-line jsx-a11y/aria-role */}
    <StyledHeading as="div" role="text">
      {quote}
      <AttributionWrapper>&nbsp;-&nbsp;{attribution}</AttributionWrapper>
    </StyledHeading>
    {renderSubtext(subText, linkText, linkUrl)}
  </CaptionedImage>
);

export default QuoteCaptionedImage;
